import BootstrapTab from 'react-bootstrap/lib/Tab'
import PropTypes from 'prop-types'
import React, {PureComponent} from 'react'

import {colors} from '../styles'
import {css} from 'glamor'

const style = {
  tabs: css({
    padding: 0,
    '& [role="tablist"]': {
      display: 'flex',
      border: 'none',
      listStyle: 'none',
      padding: 0,
      '& > li': {
        borderBottom: `1px solid ${colors.defaultBorder}`,
        flex: '1 auto',
        margin: 0,
        padding: '0 0 3px',
        position: 'relative',
        textAlign: 'center',
        '&.active': {
          borderBottom: `4px solid ${colors.actionOrange}`,
          fontWeight: '700',
          paddingBottom: 0
        },
        '& > a': {
          backgroundColor: 'transparent',
          border: 'none',
          color: colors.defaultText,
          lineHeight: '24px',
          padding: '15px 15px 10px',
          '&:focus': {
            backgroundColor: 'transparent',
            border: 'none',
            textDecoration: 'none'
          },
          '&:hover': {
            backgroundColor: 'transparent',
            border: 'none',
            textDecoration: 'none'
          }
        }
      }
    }
  })
}

export default class Tabs extends PureComponent {
  render() {
    return (
      <BootstrapTab.Container {...this.props} {...style.tabs}>
        {this.props.children}
      </BootstrapTab.Container>
    )
  }
}

Tabs.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
}
